export default __webpack_public_path__ + "b18f37dacf5a406ab12e68ba83659d09.jpg";